/**
 * 작성자 : 한영광
 * 날짜 : 2023.05.24
 * 기능 : 본사 사용자관리-사용자정보
 */

/**
 * 수정자 : 박승호
 * 날짜 : 2024.08.13
 * 수정이유 : 부서명 필드, CCTV 설정 필드, CCTV 모니터링 관리 탭 추가
 */

import { useState, useRef, useEffect, Dispatch, SetStateAction } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { IComCdList, INumbers, ITabObject, ISelectBox } from 'customTypes';
import { pageInfoState, userState } from '../../atoms';
import Tab from '../../components/Tab';
import UserInfo from './user1/userInfo';
import UserMenu from './user1/userMenu';
import TuiGrid from '../../components/Table/TuiGrid';
import styled from 'styled-components';
import { SearchOptions } from '../../assets/styles/SearchOptions';
import Input from '../../components/Input';
import { BtnGhost } from '../../components/Button';
import { COMCD_APPROVAL_YN, COMCD_LOCK_YN, COMCD_USE_YN, USER_GRANT, PMS_NORMAL_SUB_CODE, INIT_LOCK_YN_N, INIT_USE_YN_Y } from '../../_constants';
import { setComCdListState } from '../../utils/setComCdListState';
import { logPost } from '../../services/log';
import SelectBox from '../../components/SelectBox';
import { useTranslation } from 'react-i18next';
import i18n from '../../translation/i18n';
import { useGetFrozenCount } from '../../utils/getFrozenCount';
import TuiGridWrapper from '../../components/Table/TuiGridWrapper';
import BackButton from '../../components/BackButton';
import { apiGet } from '../../services/_common';
import UserCctvSetting from './user1/userCctvSetting';
import { useQuery } from '@tanstack/react-query';
import { TuiGridTwoColumnStyle } from '../../assets/styles/TuiGridTwoColumnStyle';
import illustrator from '../../assets/images/illustration/61.svg';
import useTuiGridSize from '../../hooks/useTuiGridSize';

const Root = styled.div`
  /* width: 100%;
  border-radius: 0.5rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden; */
  &.hideRoot {
    visibility: hidden;
    position: absolute;
  }
  .tui-container {
    flex-grow: 1;
    flex-shrink: 1;
    overflow: hidden;
  }
  .tableWrapper {
    flex-grow: 1;
    overflow: auto;
    display: flex;
    flex-direction: column;
  }
  input[type='checkbox'] {
    margin: 0;
    width: 1rem;
    height: 1rem;
  }
  .inputFormsWrapper {
    border-bottom: 1px solid var(--outline);
    padding: 0.5rem;
    width: 100%;
    flex-grow: 0;
    flex-shrink: 0;
    .table {
      height: fit-content;
    }
  }
  .inputFormsWrapper.smallTab {
    flex-direction: row;
    align-items: center;
    padding: 0 0.5rem;
    font-weight: 500;
    &::-webkit-scrollbar {
      -webkit-appearance: none;
      height: 0rem !important;
    }
    > div {
      user-select: none;
    }
    .tabMenuGroup {
      overflow: auto;
      width: 100%;
      &::-webkit-scrollbar {
        -webkit-appearance: none;
        height: 0rem !important;
      }

      .tabMenuGroupInner {
        display: flex;
        flex-wrap: nowrap;
        width: max-content;
      }
    }
    .tab {
      width: max-content;
      color: var(--text-secondary);
      display: flex;
      align-items: center;
      padding: 0 0.5rem;
      cursor: pointer;
      height: 3.5rem;
      border-bottom: 2px solid transparent;
    }
    .activeTab {
      font-weight: 700;
      color: var(--selected-primary);
      border-bottom: 2px solid var(--selected-primary);
    }
  }
  .formTitle {
    padding: 0 0.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    font-weight: 500;
    color: var(--text-primary);
  }
  .end {
    justify-content: end;
    > button {
      margin-left: 1rem;
    }
  }

  .thead > .tr,
  .tbody > .tr {
    > div {
      display: flex;
      align-items: center;
      padding: 0 0.5rem;
    }
    .spaceBetween {
      justify-content: space-evenly;
    }
  }
  .grid {
    display: grid;
    margin-bottom: 1rem;
    align-items: center;
    min-height: 3.4rem;
  }

  .grid100,
  .grid100T,
  .grid60,
  .grid50,
  .grid30 {
    > div > div {
      display: grid;
      grid-template-columns: 9rem 1fr;
      align-items: center;
    }
  }

  .grid100T {
    grid-template-columns: 9rem 1fr;
  }

  .grid50,
  .grid60 {
    grid-template-columns: 1fr 1fr;
  }

  .grid50 {
    grid-gap: 1rem;
  }

  .grid30 {
    grid-template-columns: 1.5fr 0.7fr 0.8fr;
  }

  .plainText {
    grid-template-columns: 9rem 1fr;

    > :last-child {
      display: block;
    }
  }

  .marginBottomNone {
    margin-bottom: 0;
  }
`;
interface IViewTableObject {
  userId: string;
  userName: string;
  gName: string;
  lockYn: string;
  approvalYn: string;
  useYn: string;
}

const TAB_INFO = 0;
const TAB_MENU = 1;
const TAB_CCTV = 2;

const Huser1 = () => {
  const { t } = useTranslation();
  const userInfo = useRecoilValue(userState);
  const { userMenuList } = userInfo;
  const [initBtnClick, setInitBtnClick] = useState(false);
  const [addBtnClick, setAddBtnClick] = useState(true);
  const [columns, setColumns] = useState<any[]>([]);
  const size = useOutletContext<any>();
  const tabInfo = useRecoilValue(pageInfoState);
  const node = useRef<any>(null);
  const [activeTabClick, setActiveTabClick] = useState(0);
  const userInfoInputFormRef = useRef<any>(null); // 인풋 폼 ref (테이블 로우를 클릭했을 때 바로 inputForm 으로 스크롤 이동시키기 위한 ref)
  // const { isBottom } = useDetectScrolledToBottom(userInfoInputFormRef); // 스크롤이 해당노드의 하단에 근접했는지 여부 (플로팅버튼 띄우기 위함)
  const [initTableState, setInitTableState] = useState<IViewTableObject[]>([]);
  const [viewTableState, setViewTableState] = useState<IViewTableObject[]>([]);
  const [viewTable, setViewTable] = useState<boolean>(true);
  const [currentTabMrCd, setCurrentTabMrCd] = useState(tabInfo.defaultMrCd);
  const [useYnComCdList, setUseYnComCdList] = useState<IComCdList[]>([]); // 사용유무 공통코드
  const [lockYnComCdList, setLockYnComCdList] = useState<IComCdList[]>([]); // 잠금유무 공통코드
  const [useYnComCdList2, setUseYnComCdList2] = useState<IComCdList[]>([]); // 사용유무 공통코드(내부 컴포넌트 용)
  const [lockYnComCdList2, setLockYnComCdList2] = useState<IComCdList[]>([]); // 잠금유무 공통코드(내부 컴포넌트 용)
  const [userGrantComCdList, setUserGrantComCdList] = useState<IComCdList[]>([]); // 사용자 권한 공통코드
  const [approvalYnComCdList, setApprovalYnComCdList] = useState<IComCdList[]>([]); // 사용유무 공통코드
  const [cctvUseYnList, setCctvUseYnList] = useState<ISelectBox[]>([]); // cctv 권한 사용유무
  const [partList, setPartList] = useState<ISelectBox[]>([]); // 부서명 메뉴 리스트
  const [positionList, setPositionList] = useState<ISelectBox[]>([]); // 직급명 메뉴 리스트
  const [camCList, setCamCList] = useState<ISelectBox[]>([]); // 관리회사명 메뉴 리스트
  const [orgUserList, setOrgUserList] = useState<any[]>([]);
  const [orgUserInfo, setOrgUserInfo] = useState([]);
  const [telNumState, setTelNumState] = useState<INumbers>({ num1: '', num2: '', num3: '' });
  const [hpNumState, setHpNumState] = useState<INumbers>({ num1: '010', num2: '', num3: '' });
  const [ipInfoState, setIpInfoState] = useState<INumbers>({ num1: '', num2: '', num3: '', num4: '' });
  const [searchOption, setSearchOption] = useState({
    userName: '',
  });
  const [searchOptionUseYn, setSearchOptionUseYn] = useState<any>({
    type: COMCD_USE_YN,
    [COMCD_USE_YN]: 'A',
    cdName: t('전체'),
    cdSort: 0,
  });
  const [searchOptionLockYn, setSearchOptionLockYn] = useState<any>({
    type: COMCD_LOCK_YN,
    [COMCD_LOCK_YN]: 'A',
    cdName: t('전체'),
    cdSort: 0,
  });
  const [searchOptionApprovalYn, setSearchOptionApprovalYn] = useState<any>({
    type: COMCD_APPROVAL_YN,
    [COMCD_APPROVAL_YN]: 'A',
    cdName: t('전체'),
    cdSort: 0,
  });

  const [newTabList, setNewTabList] = useState<ITabObject[]>();
  const [selectedRowKey, setSelectedRowKey] = useState<any>(null);
  const [lockYn, setLockYn] = useState(INIT_LOCK_YN_N); // 잠금유무 공통코드
  const [useYn, setUseYn] = useState(INIT_USE_YN_Y); // 사용유무 공통코드
  const [gCd, setGCd] = useState<{ type: 'USER_GRANT'; [USER_GRANT]: string; cdName: string }>({
    type: USER_GRANT as 'USER_GRANT',
    [USER_GRANT]: '',
    cdName: '미선택',
  });
  const [camGrantYn, setCamGrantYn] = useState<ISelectBox>({ type: 'camGrant', camGrant: '', cdName: t('미선택') }); // CCTV 권한
  const [partCd, setPartCd] = useState<ISelectBox>({ type: '', cdName: '' });
  const [positionCd, setPositionCd] = useState<ISelectBox>({ type: '', cdName: '' });
  const [camCcd, setCamCcd] = useState<ISelectBox>({ type: '', cdName: '' });
  const componentRef = useRef<HTMLDivElement>(null);
  const { tuiHeight } = useTuiGridSize(componentRef);
  const frozenCount = useGetFrozenCount();

  const { data: cctvYn } = useQuery([`headInfoGet${userInfo.hCd}`, userInfo.hCd], () => fetchHeadCctvYn(), {
    enabled: !!userInfo.hCd && (userInfo.sCd === '' || userInfo.sCd === '00000'),
  });

  const fetchHeadCctvYn = async () => {
    try {
      const req = { hCd: userInfo.hCd };
      const res = await apiGet({ path: '/head/info', req });
      return res.data.data.headInfo.cctvYn;
    } catch (error) {
      console.error(error);
      throw new Error('error');
    }
  };

  const [tabs, setTabs] = useState([
    { id: TAB_INFO, name: t('사용자 정보') },
    { id: TAB_MENU, name: t('사용자 메뉴 관리') },
  ]);

  useEffect(() => {
    if (cctvYn && cctvYn === 'Y') {
      const newTab = [...tabs, { id: TAB_CCTV, name: t('CCTV 모니터링 관리') }];
      setTabs(newTab);
    }
  }, [cctvYn]);

  useEffect(() => {
    const arr: any[] = [];
    userMenuList.map((v: any) => {
      const result = tabInfo?.tabList?.find((el: ITabObject) => el.mtCd === v.mtCd && el.mdCd === v.mdCd && el.mrCd === v.mrCd);
      if (result) {
        arr.push(result);
        setNewTabList(arr);
      }
    });
  }, [tabInfo.tabList]);

  useEffect(() => {
    setSearchOptionLockYn({ type: COMCD_LOCK_YN, [COMCD_LOCK_YN]: 'A', cdName: t('전체'), cdSort: 0 });
    setSearchOptionApprovalYn({ type: COMCD_APPROVAL_YN, [COMCD_APPROVAL_YN]: 'A', cdName: t('전체'), cdSort: 0 });
    setSearchOptionUseYn({ type: COMCD_USE_YN, [COMCD_USE_YN]: 'A', cdName: t('전체'), cdSort: 0 });

    setColumns([
      {
        header: t('ID'),
        name: 'userId',
        sortable: true,
        width: 100,
        renderer: { classNames: ['text_secondary'] },
      },
      {
        header: t('사용자명'),
        name: 'userName',
        sortable: true,
        minWidth: 160,
        renderer: { classNames: ['text_secondary'] },
      },
      {
        header: t('권한'),
        name: 'gName',
        align: 'center',
        sortable: true,
        filter: 'select',
        minWidth: 120,
      },
      {
        header: t('잠금유무'),
        name: 'lockYnCdName',
        align: 'center',
        sortable: true,
        minWidth: 80,
      },
      {
        header: t('승인여부'),
        name: 'approvalYnCdName',
        align: 'center',
        sortable: true,
        minWidth: 80,
      },
      {
        header: t('사용유무'),
        name: 'useYnCdName',
        align: 'center',
        sortable: true,
        minWidth: 80,
      },
    ]);
  }, [i18n.language]);

  useEffect(() => {
    getUserHeadAPI().then((res: any) => {
      if (res.status === 200) {
        setComCdListState(COMCD_APPROVAL_YN, setApprovalYnComCdList, true);
        setComCdListState(COMCD_USE_YN, setUseYnComCdList, true);
        setComCdListState(COMCD_LOCK_YN, setLockYnComCdList, true);
        setComCdListState(COMCD_USE_YN, setUseYnComCdList2, false);
        setComCdListState(COMCD_LOCK_YN, setLockYnComCdList2, false);
        setComCdListState(USER_GRANT, setUserGrantComCdList, false, 'etc1', 'H');

        setPmsNormalSubList('L', setPartList);
        setPmsNormalSubList('M', setPositionList);
        setPmsNormalSubList('O', setCamCList);

        logPost({
          hCd: userInfo.hCd,
          sCd: userInfo.sCd,
          userId: userInfo.userId,
          menu: '사용자 정보 / 메뉴 관리',
          action: '조회',
          etc: ``,
        });
      }
    });
  }, []);

  useEffect(() => {
    if (userInfo.hCd?.substring(0, 1)?.toLowerCase() === 'h') {
      getCctvGrantMenuAPI(userInfo.hCd).then((res) => {
        const { data } = res;
        const cameraUseYn = data.data.filter((item: any) => item.useYn === 'Y');
        const newArr = cameraUseYn.map((el: any) => ({ type: 'camGrant', camGrant: el.gCd, cdName: el.gName }));
        const grantSort = newArr.sort((a: ISelectBox, b: ISelectBox) => (a.cdName < b.cdName ? -1 : a.cdName > b.cdName ? 1 : 0));
        setCctvUseYnList(grantSort);
      });
    }
  }, [userInfo.hCd]);

  useEffect(() => {
    applyFilter(initTableState);
  }, [searchOption, searchOptionUseYn[COMCD_USE_YN], searchOptionLockYn[COMCD_LOCK_YN], searchOptionApprovalYn[COMCD_APPROVAL_YN]]);

  useEffect(() => {
    if (addBtnClick) {
      setHpNumState({ num1: '010', num2: '', num3: '' });
      setTelNumState({ num1: '', num2: '', num3: '' });
      setIpInfoState({ num1: '', num2: '', num3: '', num4: '' });
    }
  }, [addBtnClick]);

  const applyFilter = (array: any[]) => {
    // 검색옵션 변경됐을 때 필터링 처리
    // 필터링 기준
    const filterOptions = {
      userName: searchOption.userName,
    };
    // 필터링된 어레이 리턴, 대소문자구분X
    const filteredArray = array.filter((item: any) => {
      return item.userName?.toLowerCase()?.includes(filterOptions.userName?.toLowerCase());
    });
    const lockFilter = YNFilter(filteredArray, 'lockYn', searchOptionLockYn[COMCD_LOCK_YN]);
    const approvalFilter = YNFilter(lockFilter, 'approvalYn', searchOptionApprovalYn[COMCD_APPROVAL_YN]);
    const result = YNFilter(approvalFilter, 'useYn', searchOptionUseYn[COMCD_USE_YN]);
    if (result.length > 0) {
      const newTableState: Array<any> = [];
      for (const v of result) {
        newTableState.push({
          userId: v.userId,
          userName: v.userName,
          gName: v.gName,
          lockYn: v.lockYn,
          approvalYn: v.approvalYn,
          useYn: v.useYn,
          lockYnCdName: v.lockYn === 'Y' ? t('잠금') : t('미잠금'),
          approvalYnCdName: v.approvalYn === 'Y' ? t('승인') : t('미승인'),
          useYnCdName: v.useYn === 'Y' ? t('사용') : t('미사용'),
        });
      }
      setViewTableState(newTableState);
    } else {
      setViewTableState([]);
    }
  };

  const YNFilter = (initialArray: IViewTableObject[], key: string, option: any) => {
    if (option === 'Y') {
      return initialArray.filter((el: any) => el[key] === 'Y');
    }
    if (option === 'N') {
      return initialArray.filter((el: any) => el[key] === 'N');
    }
    return initialArray;
  };

  const subCodeFilter = (grCd: string) => {
    const codeFilter = PMS_NORMAL_SUB_CODE.filter((el) => el.code.includes(grCd));
    return codeFilter[0].type;
  };

  // 사용자 정보 리스트 조회 API
  const getUserHeadAPI = async () => {
    const req = { hCd: userInfo.hCd };
    const res = await apiGet({ path: '/user/head', req });
    const { data, statusCode } = res.data;
    if (statusCode === 200) {
      const newTableState: Array<any> = [];
      for (const v of data.userList) {
        newTableState.push({
          userId: v.userId,
          userName: v.userName,
          gName: v.gName,
          lockYn: v.lockYn,
          approvalYn: v.approvalYn,
          pwdCheckyn: v.pwdCheckyn,
          useYn: v.useYn,
          lockYnCdName: v.lockYn === 'Y' ? t('잠금') : t('미잠금'),
          approvalYnCdName: v.approvalYn === 'Y' ? t('승인') : t('미승인'),
          useYnCdName: v.useYn === 'Y' ? t('사용') : t('미사용'),
        });
      }
      setOrgUserList(data.userList);
      setViewTableState(newTableState);
      setInitTableState(newTableState);
    } else {
      // toast.error(t(ERROR));
    }
    return res;
  };

  // 본사 CCTV 권한 메뉴 조회 API
  const getCctvGrantMenuAPI = async (hCd: string) => {
    const req = { hCd };
    const res = await apiGet({ path: '/cam/grant', req });
    return res;
  };

  // 본사 일반 - 부서명, 직급명, 관리회사명 코드 조회
  const setPmsNormalSubList = async (subCd: string, setState: Dispatch<SetStateAction<ISelectBox[]>>) => {
    const req = { hCd: userInfo.hCd, sCd: userInfo.sCd, subCd };
    const res = await apiGet({ path: '/code/pmsNormalTitle', req });
    const { data, status } = res;
    const cdFind: string = PMS_NORMAL_SUB_CODE.find((el) => el.code.includes(subCd))?.type || '';
    if (status === 200) {
      const defaultObject = { type: cdFind, [cdFind]: '', cdName: t('미선택') };
      const newArr = data.data.pmsNormalTitleList?.map((el: ISelectBox) => ({ type: cdFind, [cdFind]: el.subCd, cdName: el.cdName }));
      setState([defaultObject, ...newArr]);
    }
  };

  const onClickInitiateSearchOption = () => {
    setSearchOption((prev: any) => ({ ...prev, userName: '' }));
    setSearchOptionLockYn({ type: COMCD_LOCK_YN, [COMCD_LOCK_YN]: 'A', cdName: t('전체'), cdSort: 0 });
    setSearchOptionApprovalYn({ type: COMCD_APPROVAL_YN, [COMCD_APPROVAL_YN]: 'A', cdName: t('전체'), cdSort: 0 });
    setSearchOptionUseYn({ type: COMCD_USE_YN, [COMCD_USE_YN]: 'A', cdName: t('전체'), cdSort: 0 });
    setCamGrantYn({ type: 'camGrant', camGrant: '', cdName: t('미선택') });
    setPartCd({ type: subCodeFilter('L'), [subCodeFilter('L')]: '', cdName: t('미선택') });
    setPositionCd({ type: subCodeFilter('M'), [subCodeFilter('M')]: '', cdName: t('미선택') });
    setCamCcd({ type: subCodeFilter('O'), [subCodeFilter('O')]: '', cdName: t('미선택') });
    getUserHeadAPI();
    setInitBtnClick(true);
    setAddBtnClick(true);
    setActiveTabClick(TAB_INFO);
  };

  // 사용자 Row 클릭
  const onClickRow = (rowData: any) => {
    setSelectedRowKey(rowData.rowKey);
    setAddBtnClick(false);

    const user = orgUserList.find((v: any) => v.userId === rowData.userId);
    if (user) {
      setOrgUserInfo(user);

      const splitHpNumber = user.hpNum?.split('-');
      setHpNumState({ num1: splitHpNumber[0] || '', num2: splitHpNumber[1] || '', num3: splitHpNumber[2] || '' });

      const splitTelNumber = user.telNum?.split('-') ?? ['', '', ''];
      setTelNumState({ num1: splitTelNumber[0] || '', num2: splitTelNumber[1] || '', num3: splitTelNumber[2] || '' });

      const splitIpNumber = user.ipInfo?.split('.');
      setIpInfoState({ num1: splitIpNumber[0] || '', num2: splitIpNumber[1] || '', num3: splitIpNumber[2] || '', num4: splitIpNumber[3] || '' });
    }
    if (size.innerSize.W <= 1024) {
      setViewTable(false);
    }
  };

  const onClickTab = (mrCd: string) => {
    setCurrentTabMrCd(mrCd);
  };

  const onClickSubTab = (tabId: number) => {
    setActiveTabClick(tabId);
  };

  const backToMain = () => {
    setViewTable(true);
    setSelectedRowKey(null);
  };

  const addBtnAction = () => {
    setInitBtnClick(true);
    setAddBtnClick(true);
    setUseYn(INIT_USE_YN_Y);
    setLockYn(INIT_LOCK_YN_N);
    setActiveTabClick(TAB_INFO);
    setGCd({ type: USER_GRANT as 'USER_GRANT', [USER_GRANT]: '', cdName: '미선택' });
    setCamGrantYn({ type: 'camGrant', camGrant: '', cdName: t('미선택') });
    setPartCd({ type: subCodeFilter('L'), [subCodeFilter('L')]: '', cdName: t('미선택') });
    setPositionCd({ type: subCodeFilter('M'), [subCodeFilter('M')]: '', cdName: t('미선택') });
    setCamCcd({ type: subCodeFilter('O'), [subCodeFilter('O')]: '', cdName: t('미선택') });

    if (size.innerSize.W <= 1024) {
      setViewTable(false);
    }
  };

  const renderPage = () => {
    if (activeTabClick === TAB_MENU) {
      return <UserMenu orgUserInfo={orgUserInfo} setOrgUserInfo={setOrgUserInfo} initBtnClick={initBtnClick} setInitBtnClick={setInitBtnClick} viewTableState={initTableState} />;
    }
    if (activeTabClick === TAB_CCTV) {
      return <UserCctvSetting orgUserInfo={orgUserInfo} setOrgUserInfo={setOrgUserInfo} userInfo={userInfo} />;
    }
    return (
      <UserInfo
        orgUserInfo={orgUserInfo}
        setOrgUserInfo={setOrgUserInfo}
        applyFilter={applyFilter}
        orgUserList={orgUserList}
        setOrgUserList={setOrgUserList}
        getUserHeadAPI={getUserHeadAPI}
        lockYnComCdList={lockYnComCdList2}
        useYnComCdList={useYnComCdList2}
        userGrantComCdList={userGrantComCdList}
        initBtnClick={initBtnClick}
        setInitBtnClick={setInitBtnClick}
        addBtnClick={addBtnClick}
        setSelectedRowKey={setSelectedRowKey}
        hpNumState={hpNumState}
        telNumState={telNumState}
        ipInfoState={ipInfoState}
        setHpNumState={setHpNumState}
        setTelNumState={setTelNumState}
        setIpInfoState={setIpInfoState}
        useYn={useYn}
        lockYn={lockYn}
        setUseYn={setUseYn}
        setLockYn={setLockYn}
        cctvUseYnList={cctvUseYnList}
        camGrantYn={camGrantYn}
        setCamGrantYn={setCamGrantYn}
        partList={partList}
        positionList={positionList}
        camCList={camCList}
        partCd={partCd}
        setPartCd={setPartCd}
        positionCd={positionCd}
        setPositionCd={setPositionCd}
        camCcd={camCcd}
        setCamCcd={setCamCcd}
        gCd={gCd}
        setGCd={setGCd}
        cctvYn={cctvYn}
      />
    );
  };

  if (userInfo.gCd === 'HU') {
    return (
      <div className='contents'>
        <Tab tabList={newTabList || tabInfo.tabList} currentTabMrCd={currentTabMrCd} setCurrentTabMrCd={setCurrentTabMrCd} onClickTab={onClickTab} size={size} />
        <div className={`content-container ${size.innerSize.W > 1024 ? 'twoColumn column-55 max800' : 'oneColumn'}`}>
          <TuiGridTwoColumnStyle className={size.innerSize.W > 1024 || viewTable ? 'showRoot' : 'hideRoot'}>
            <div className='emptyData'>
              <img src={illustrator} alt='' />
              <p className='main_text text-center'>{t('해당 페이지의 권한이 없습니다 관리자에게 문의해 주시기 바랍니다')}</p>
            </div>
          </TuiGridTwoColumnStyle>
        </div>
      </div>
    );
  }

  return (
    <div className='contents'>
      <Tab tabList={newTabList || tabInfo.tabList} currentTabMrCd={currentTabMrCd} setCurrentTabMrCd={setCurrentTabMrCd} onClickTab={onClickTab} size={size} />
      <div className={`content-container ${size.innerSize.W > 1024 ? 'twoColumn column-55 max800' : 'oneColumn'}`}>
        <Root className={size.innerSize.W > 1024 || viewTable ? 'showRoot' : 'hideRoot'}>
          <SearchOptions align='left'>
            {size.innerSize.W > 1024 ? (
              <>
                <div className='inputsWrapper'>
                  <div className='inputForm-row'>
                    <div className='inputForm-col withLabelComCf'>
                      <label htmlFor='lockYn'>{t('잠금유무')}</label>
                      <SelectBox
                        options={lockYnComCdList}
                        defaultOption={searchOptionLockYn.cdName}
                        state={searchOptionLockYn}
                        setState={setSearchOptionLockYn}
                        stateKey={COMCD_LOCK_YN}
                        initiateKey={searchOptionLockYn[COMCD_LOCK_YN]}
                        filterbar='filter-1-left'
                      />
                    </div>
                  </div>
                  <div className='inputForm-row'>
                    <div className='inputForm-col withLabelComCf'>
                      <label htmlFor='approvalYn'>{t('승인여부')}</label>
                      <SelectBox
                        options={approvalYnComCdList}
                        defaultOption={searchOptionApprovalYn.cdName}
                        state={searchOptionApprovalYn}
                        setState={setSearchOptionApprovalYn}
                        stateKey={COMCD_APPROVAL_YN}
                        initiateKey={searchOptionApprovalYn[COMCD_APPROVAL_YN]}
                        filterbar='filter-1-left'
                      />
                    </div>
                  </div>
                  <div className='inputForm-row'>
                    <div className='inputForm-col withLabelComCf'>
                      <label htmlFor='useYn'>{t('사용유무')}</label>
                      <SelectBox
                        options={useYnComCdList}
                        defaultOption={searchOptionUseYn.cdName}
                        state={searchOptionUseYn}
                        setState={setSearchOptionUseYn}
                        stateKey={COMCD_USE_YN}
                        initiateKey={searchOptionUseYn[COMCD_USE_YN]}
                        filterbar='filter-1-center'
                      />
                    </div>
                  </div>
                  <div className='inputForm-row'>
                    <div className='inputForm-col'>
                      <Input label='' placeholder={t('사용자명')} type='text' id='userName' name='userName' state={searchOption} setState={setSearchOption} />
                    </div>
                  </div>
                </div>
                <div className='inputsWrapper'>
                  <div className='secondSearchOption'>
                    <div className='flex-basic textBtnGroup'>
                      <BtnGhost onClick={onClickInitiateSearchOption}>{t('초기화')}</BtnGhost>
                    </div>
                    <div className='flex-basic iconBtnGroup'>
                      <BtnGhost onClick={() => addBtnAction()}>
                        <span className='material-symbols-rounded'>add</span>
                        {t('등록')}
                      </BtnGhost>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className='filter-wrapper'>
                <div className='inputsWrapper'>
                  <div className='inputForm-row' style={{ width: '100%' }}>
                    <div className='inputForm-col'>
                      <Input label='' placeholder={t('사용자명')} type='text' id='userName' name='userName' state={searchOption} setState={setSearchOption} ico='search' />
                    </div>
                  </div>
                </div>
                <div className='inputsWrapper'>
                  <div className='flex-basic iconBtnGroup'>
                    <BtnGhost onClick={() => addBtnAction()}>
                      <span className='material-symbols-rounded'>add</span>
                      {t('등록')}
                    </BtnGhost>
                  </div>
                </div>
              </div>
            )}
          </SearchOptions>
          <TuiGridWrapper componentRef={componentRef}>
            <TuiGrid data={viewTableState} columns={columns} perPage={15} onClickRow={onClickRow} rowKey={selectedRowKey} frozenCount={frozenCount} height={tuiHeight} />
          </TuiGridWrapper>
        </Root>
        {(size.innerSize.W > 1024 || !viewTable) && (
          <Root>
            {addBtnClick ? (
              <div className='inputFormsWrapper flexRowEm'>
                {size.innerSize.W <= 1024 && <BackButton func={() => backToMain()} />}
                <div className='formTitle'>{t('새로운 사용자')}</div>
              </div>
            ) : (
              <div className='inputFormsWrapper smallTab'>
                {size.innerSize.W <= 1024 && <BackButton func={() => backToMain()} />}
                <div className='tabMenuGroup'>
                  <div className='tabMenuGroupInner'>
                    {tabs.map((el) => (
                      <div key={el.id} className={`tab ${el.id === activeTabClick && 'activeTab'} userMenu`} role='button' tabIndex={0} onClick={() => onClickSubTab(el.id)}>
                        {t(el.name)}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            {renderPage()}
          </Root>
        )}
      </div>
    </div>
  );
};

export default Huser1;
